import { io } from 'socket.io-client';

class SocketService {
    constructor() {
        this.socket = null;
        this.listeners = new Map();
    }

    connect(token) {
        // มี socket อยู่แล้วและยังเชื่อมต่ออยู่ หรือกำลังเชื่อมต่อ/รี-คอนเนกต์ (active)
        // ใช้ instance เดิม เพื่อกันการสร้าง socket ซ้ำเมื่อหลายคอมโพเนนต์เรียก connect() พร้อมกัน
        if (this.socket && (this.socket.connected || this.socket.active)) {
            return this.socket;
        }

        // Socket.io ต้องเชื่อมต่อที่ "origin" (namespace '/') ไม่ใช่ path ของ REST API
        // ค่า REACT_APP_API_URL = '/api' ถ้าส่งเข้า io() ตรงๆ จะถูกตีความเป็น namespace
        // ทำให้เกิด error "Invalid namespace" — จึงต้องตัด path ออก เหลือแค่ origin
        let serverUrl = process.env.REACT_APP_API_URL || '';
        if (/^https?:\/\//i.test(serverUrl)) {
            // เป็น full URL (เช่น https://host/api) -> ใช้แค่ origin
            try { serverUrl = new URL(serverUrl).origin; } catch (e) { serverUrl = ''; }
        } else {
            // เป็น path เปล่า (เช่น /api) -> ใช้ origin ปัจจุบันของเบราว์เซอร์
            serverUrl = '';
        }

        this.socket = io(serverUrl, {
            auth: { token },
            transports: ['websocket', 'polling'],
            reconnection: true,
            reconnectionAttempts: 5,
            reconnectionDelay: 1000,
            reconnectionDelayMax: 5000,
            timeout: 10000,
            autoConnect: true
        });

        this.socket.on('connect', () => {
            console.log('✓ Socket connected:', this.socket.id);
        });

        this.socket.on('disconnect', (reason) => {
            console.log('Socket disconnected:', reason);
        });

        this.socket.on('connect_error', (error) => {
            // ไม่ต้อง log error มากเกินไป เพราะอาจทำให้ console เต็ม
            console.warn('Socket connection error (will retry):', error.message);
        });

        return this.socket;
    }

    disconnect() {
        if (this.socket) {
            this.socket.disconnect();
            this.socket = null;
        }
    }

    // Join a conversation room
    joinConversation(conversationId) {
        if (this.socket?.connected) {
            this.socket.emit('join_conversation', conversationId);
        }
    }

    // Leave a conversation room
    leaveConversation(conversationId) {
        if (this.socket?.connected) {
            this.socket.emit('leave_conversation', conversationId);
        }
    }

    // Send typing indicator
    sendTyping(conversationId, isTyping) {
        if (this.socket?.connected) {
            this.socket.emit('typing', { conversationId, isTyping });
        }
    }

    // Mark messages as read
    markRead(conversationId) {
        if (this.socket?.connected) {
            this.socket.emit('mark_read', conversationId);
        }
    }

    // Event listeners
    on(event, callback) {
        if (this.socket) {
            this.socket.on(event, callback);
        }
    }

    off(event, callback) {
        if (this.socket) {
            this.socket.off(event, callback);
        }
    }

    emit(event, data) {
        if (this.socket?.connected) {
            this.socket.emit(event, data);
        }
    }

    isConnected() {
        return this.socket?.connected || false;
    }
}

const socketService = new SocketService();
export default socketService;
